import React, { useState } from "react";
import { db } from "./firebase";
import { collection, addDoc } from "firebase/firestore"; 
import "./Contact.css";

const Contact = () => {
  const [voornaam, setVoornaam] = useState("");
  const [achternaam, setAchternaam] = useState("");
  const [email, setEmail] = useState("");
  const [telefoonnummer, setTelefoonnummer] = useState("");
  const [bericht, setBericht] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage(null);
    setSuccessMessage(null);
    try {
      await addDoc(collection(db, "contact"), {
        voornaam,
        achternaam,
        email,
        telefoonnummer,
        bericht,
        createdAt: new Date(),
      });
      setSuccessMessage("Bericht succesvol verzonden!");
      setVoornaam("");
      setAchternaam("");
      setEmail("");
      setTelefoonnummer("");
      setBericht("");
    } catch (error) {
      setErrorMessage("Fout bij het verzenden van het bericht. Probeer het opnieuw.");
    }
    setLoading(false);
  };

  return (
    <div className="container">
      <div className="contact-container">
        <div className="contact-left">
          <h1>Contact</h1>
          {successMessage && <p className="success-message">{successMessage}</p>}
          {errorMessage && <p className="error-message">{errorMessage}</p>}
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Voornaam*</label>
                <input
                  type="text"
                  value={voornaam}
                  onChange={(e) => setVoornaam(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label>Achternaam*</label>
                <input
                  type="text"
                  value={achternaam}
                  onChange={(e) => setAchternaam(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Email*</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label>Telefoonnummer</label>
                <input
                  type="tel"
                  value={telefoonnummer}
                  onChange={(e) => setTelefoonnummer(e.target.value)}
                />
              </div>
            </div>
            <label>Bericht*</label>
            <textarea
              rows="5"
              value={bericht}
              onChange={(e) => setBericht(e.target.value)}
              required
            />
            <button type="submit" disabled={loading}>
              {loading ? "Verzenden..." : "Verzenden"}
            </button>
          </form>
        </div>
        <div className="contact-right">
          <h1>Contactgegevens</h1>
          <p>
            Email: <a href="werkeilandFlevoland@gmail.com">werkeilandFlevoland@gmail.com</a>
          </p>
          <h1>Adres</h1>
          <p>Werkeiland Lelystad</p>
          <div className="map-container">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2428.7445192436085!2d5.4129970769139675!3d52.501864072056335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c62150642588c1%3A0x8293d3598042e75e!2sPioniersstraat%2C%208244%20PD%20Lelystad!5e0!3m2!1snl!2snl!4v1741530256804!5m2!1snl!2snl" 
            width="600"
            height="300"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="map"
    />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
